import styled from "styled-components";
import { Icon } from "discover.medical.react-component-library";

export const StyledPdfFilesDiv = styled.div`
  margin-top: ${({ theme }) => theme.space.md};
  @media print {
    display: none;
  }
`;

export const StyledPdfFilesTitle = styled.span`
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-size: ${({ theme }) => theme.font.size.md};
`;

export const StyledPdfFilesIcon = styled(Icon)`
  vertical-align: middle;
  margin-right: 0.4rem;
`;
